import target from './target';
import items from './items';
import assign from './assign';
import assignorg from './assignorg';
import enter from './enter';
import subresult from './subresult';
import tagresult from './tagresult';
import expertAssign from './expertAssign';
import expertReview from './expertReview';
import expertResult from './expertResult';
import expertResultTotal from './expertResultTotal';
import totalresult from './totalresult';
import statresult from './statresult';
import myenter from './myenter';
import audit from './audit';
import auditorg from './auditorg';
import swot from './swot';
import swotConvert from './swotConvert';
import swotExpertConvert from './swotExpertConvert';
import swotSelfAssess from './swotSelfAssess';
import swotExpert from './swotExpert';
import swotAuthTic from './swotAuthTic';
import org from './org';
import earlywarning from './earlywarning';
import summary from './summary';
import assignview from './assignview';
import subresultall from './subresultall';
import subResultImport from './subResultImport';
import team from './team';
import teamMember from './teammember';
import fillingRate from './fillingRate';
import selfAssessment from './selfAssessment';
import authentication from './authentication';
import assignauthentication from './assignauthentication';
import baseInfo from './baseInfo';
import earlyWarnSelfAssess from './earlyWarnSelfAssess';
import earlyWarnAuthTic from './earlyWarnAuthTic';
import earlyWarnExpert from './earlyWarnExpert';
import majorSort from './majorSort';
import majorSortSelfAssess from './majorSortSelfAssess';
import majorSortExpert from './majorSortExpert';
import majorSortAuthTic from './majorSortAuthTic';
import targetAnalysisByOrg from './targetAnalysisByOrg';
import fileFolder from './fileFolder';
import file from './file';
import targetTree from './targetTree';
import report from './report';
import reportByOrg from './reportByOrg';
import auditResult from './single/auditresult';
import auditResultByOrg from './single/auditresultbyorg';
import scoreSummary from './scoreSummary'

export default {
    target,
    items,
    assign,
    assignorg,
    enter,
    subresult,
    tagresult,
    expertAssign,
    expertReview,
    expertResult,
    expertResultTotal,
    totalresult,
    statresult,
    myenter,
    audit,
    auditorg,
    swot,
    majorSort,
    org,
    earlywarning,
    summary,
    assignview,
    subresultall,
    teamMember,
    team,
    fillingRate,
    swotConvert,
    swotExpertConvert,
    selfAssessment,
    authentication,
    assignauthentication,
    swotSelfAssess,
    swotAuthTic,
    swotExpert,
    baseInfo,
    earlyWarnSelfAssess,
    earlyWarnExpert,
    earlyWarnAuthTic,
    majorSortSelfAssess,
    majorSortAuthTic,
    majorSortExpert,
    targetAnalysisByOrg,
    fileFolder,
    file,
    targetTree,
    subResultImport,
    report,
    reportByOrg,
    auditResult,
    auditResultByOrg,
    scoreSummary
}